export const UserIcon = ({ className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.666 10H5.33268C3.85992 10 2.66602 11.1939 2.66602 12.6667V14H13.3327V12.6667C13.3327 11.1939 12.1388 10 10.666 10Z"
        fill="black"
      />
      <path
        d="M10.666 10H5.33268C3.85992 10 2.66602 11.1939 2.66602 12.6667V14H13.3327V12.6667C13.3327 11.1939 12.1388 10 10.666 10Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99935 7.33333C9.47211 7.33333 10.666 6.13943 10.666 4.66667C10.666 3.19391 9.47211 2 7.99935 2C6.52659 2 5.33268 3.19391 5.33268 4.66667C5.33268 6.13943 6.52659 7.33333 7.99935 7.33333Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
